import { select, put, take, call, all } from 'redux-saga/effects'
import axios from 'axios'
import { post } from '../../helpers/requests'

import {
  showToastMessage,
  changeFooterStatus
} from '../../actions'

import {
  getAuthStatus,
  getToken
} from '../selectors'

import usersTask from '../subtask/users'

import removeToken from './removeToken'
import * as actions from '../../actions/actionTypes'
import lockMembership from './lockMembership'
import retrier from './retrier'

export default function* authenticate() {
  let loggedInStatus = yield select(getAuthStatus);
  let token = yield select(getToken);

  // console.log('token ', token)
  // Only for web.
  if (!token) {
    yield call(removeToken)
    yield put({
      type: actions.USER_AUTHENTICATE_FAILURE,
    })
  }

  // Attempt login For both web and mobile
  if (
    token && // Token is present already in the redux store
    !loggedInStatus.getIn(['isLoggedIn']) // If user is not already logged in
    && !loggedInStatus.getIn(['isLogginFailed'])) { // If user has no login related errors

    yield put({
      type: actions.USER_AUTHENTICATE,
    })
    try {
      // Get stored credentials
      const savedEmail = localStorage.getItem('savedEmail');
      const savedPassword = localStorage.getItem('savedPassword');

      if (savedEmail && savedPassword) {
        // Attempt login with stored credentials
        const loginResponse = yield call(axios, post(`${process.env.REACT_APP_WHITELABEL_URL}/auth/login`, {
          email: savedEmail,
          password: savedPassword
        }));

        // Check validity
        const validTill = new Date(loginResponse.data.user.validTill);
        const today = new Date();
        // Add 12 hours grace period
        const gracePeriod = 12 * 60 * 60 * 1000; // 12 hours in milliseconds
        const validTillWithGrace = new Date(validTill.getTime() + gracePeriod);

        if (today > validTillWithGrace) {
          yield call(removeToken);
          yield put(showToastMessage('❗️Your subscription has expired. Please login again.'));
          yield put({
            type: actions.USER_AUTHENTICATE_FAILURE,
          });
          return;
        }

        // Update token if login successful
        if (loginResponse.data.token) {
          localStorage.setItem('token', loginResponse.data.token);
        }
      }

      const userDataArray = yield call(retrier, [call(usersTask.get)], 'authenticate');

      userData = userDataArray[0];
      if (!userData) {
        const eventId = pushToSentry('Internet connection seems to be down')
        yield put({
          type: actions.ADD_SENTRY_ERROR,
          payload: {
            error: 'Internet connection seems to be down',
            eventId
          }
        })
      }

      if (userData.isLoggedIn) {
        userData.details.email = savedEmail;
        yield put({
          type: actions.USER_AUTHENTICATE_SUCCESS,
          payload: {
            userData,
          }
        })
        localStorage.removeItem('savedPassword');
      } else {
        yield call(removeToken)
        yield put({
          type: actions.USER_AUTHENTICATE_FAILURE,
        })
      }

    } catch (e) {
      yield call(removeToken)
      yield put({
        type: actions.USER_AUTHENTICATE_FAILURE,
      })
    }
  } else if (token && !loggedInStatus.getIn(['isLoggedIn'])) {
    yield call(removeToken)
    yield put({
      type: actions.USER_AUTHENTICATE_FAILURE,
    })
  }
}
